$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * smooth anchor scroll
    // *
    // * Native scroll-behavior: smooth has a fixed, short duration on mobile
    // * browsers, so long distances feel like a jump. This animates same-page
    // * anchor links with a duration based on the scroll distance.
    // *
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function smoothScrollTo(targetY, callback) {
        var html = document.documentElement,
            startY = window.pageYOffset,
            distance = targetY - startY,
            duration = Math.min(Math.max(Math.abs(distance) / 3, 500), 1400),
            startTime = null,
            cancelled = false;

        function cancel() {
            cancelled = true;
        }

        function cleanup() {
            html.style.scrollBehavior = '';
            window.removeEventListener('wheel', cancel);
            window.removeEventListener('touchstart', cancel);
        }

        if (reducedMotion.matches || Math.abs(distance) < 2) {
            html.style.scrollBehavior = 'auto';
            window.scrollTo(0, targetY);
            cleanup();
            callback();
            return;
        }

        // disable native smooth scrolling while animating, otherwise every frame is smoothed again
        html.style.scrollBehavior = 'auto';
        window.addEventListener('wheel', cancel, { passive: true });
        window.addEventListener('touchstart', cancel, { passive: true });

        function step(time) {
            if (cancelled) {
                cleanup();
                return;
            }
            if (startTime === null) startTime = time;

            var progress = Math.min((time - startTime) / duration, 1),
                eased = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;

            window.scrollTo(0, startY + distance * eased);

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                cleanup();
                callback();
            }
        }

        requestAnimationFrame(step);
    }

    $(document).on('click', 'a[href*="#"]', function (e) {
        if (e.isDefaultPrevented() || this.pathname !== location.pathname || this.hostname !== location.hostname || this.hash.length < 2) return;

        var target = document.getElementById(decodeURIComponent(this.hash.slice(1)));
        if (!target) return;

        e.preventDefault();

        // close mobile navigation, otherwise the body is not scrollable
        $(".js-navmobile-button, .js-navmobile").removeClass("active");

        var offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 94,
            targetY = target.getBoundingClientRect().top + window.pageYOffset - offset,
            hash = this.hash;

        smoothScrollTo(Math.max(targetY, 0), function () {
            if (location.hash !== hash) {
                history.pushState(null, '', hash);
                $(window).trigger('hashchange');
            }

            // move focus for keyboard and screenreader users
            if (!$(target).is('a, button, input, select, textarea, [tabindex]')) {
                target.setAttribute('tabindex', '-1');
            }
            target.focus({ preventScroll: true });
        });
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navmobile-button").click(function () {
        $(this).toggleClass("active");
        $(".js-navmobile").toggleClass("active")
    });

    $(".js-navmobile-sub-button").click(function(e) {
        e.preventDefault();

        const $thisParent = $(this).parents(".js-navmobile-parent");

        // Alle anderen aktiven Parents deaktivieren
        $(".js-navmobile-parent.open").not($thisParent).removeClass("open").find(".js-navmobile-sub").slideUp();

        // Diesen Parent toggeln
        $thisParent.toggleClass("open").find(".js-navmobile-sub").slideToggle();
    });

    $(".js-navmobile-parent:has(li.active) .js-navmobile-sub-button").trigger("click")


    $('.js-header-sub-toggle').on('click', function(e) {
        e.preventDefault();
        const btn = $(this);
        const li = btn.closest('li.parent');
        const sub = li.find('> .header__sub');
        const isOpen = li.hasClass('open');

        // Alle anderen Submenus schließen
        $('.header__nav li.parent').removeClass('open').find('> .header__sub')
            .attr('aria-hidden', 'true')
            .attr('inert', '')
            .find('a, button').attr('tabindex', '-1');
        $('.js-header-sub-toggle').attr('aria-expanded', 'false');

        if (!isOpen) {
            // Dieses Submenu öffnen
            li.addClass('open');
            sub.attr('aria-hidden', 'false')
               .removeAttr('inert')          // <-- Wichtig!
               .find('a, button').removeAttr('tabindex'); // fokussierbar machen
            btn.attr('aria-expanded', 'true');
        } else {
            btn.attr('aria-expanded', 'false');
        }
    });

    // Fokus-Out zum automatischen Schließen
    $('.header__nav li.parent').on('focusout', function(e) {
        const li = $(this);
        const newFocusTarget = e.relatedTarget;

        // Prüfen, ob das neue Fokusziel existiert UND ob es sich außerhalb des aktuellen li.parent befindet
        if (!li[0].contains(newFocusTarget)) {
            const sub = li.find('> .header__sub');
            const toggleBtn = li.find('> .js-header-sub-toggle');
            
            li.removeClass('open');
            sub.attr('aria-hidden', 'true')
            .attr('inert', '')
            .find('a, button').attr('tabindex', '-1');
            toggleBtn.attr('aria-expanded', 'false');
        }
    });

    // ESC schließt alle
    $(document).on('keydown', function(e) {
        if (e.key === "Escape") {
            const $openParent = $('.header__nav li.parent.open');
            
            if ($openParent.length) {
                // 1. Fokus retten: Bevor wir das Menü verstecken, setzen wir den Fokus zurück auf den Toggle-Button
                $openParent.find('.js-header-sub-toggle').focus();

                // 2. Danach das Menü sicher schließen
                const sub = $openParent.find('> .header__sub');
                $openParent.removeClass('open');
                sub.attr('aria-hidden', 'true')
                .attr('inert', '')
                .find('a, button').attr('tabindex', '-1');
                $openParent.find('> .js-header-sub-toggle').attr('aria-expanded', 'false');
            }
        }
    });

    $("li.parent a").on("mouseenter", function() {
        $(this).siblings(".header__sub").removeAttr('inert');
    })




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-heroslider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {

            var $currentContainer = $(this);
            var $slider = $currentContainer.find(".js-heroslider-track");
            
            var autoPlayData = $slider.data("autoplay");
            
            // Initialisiere Standardwerte
            var isAutoplay = false;
            var playSpeed = 3000; // Dein Standard-Fallback

            // Wenn der Wert existiert und eine Zahl ist
            if (autoPlayData && !isNaN(autoPlayData)) {
                isAutoplay = true;
                playSpeed = parseInt(autoPlayData) * 1000; // Umrechnung von Sekunden in ms
            }

            $slider.slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: isAutoplay, // Dynamischer Wert
                autoplaySpeed: playSpeed, // Dynamischer Wert
                speed: 800,
                waitForAnimate: true,
                dots: false,
                pauseOnHover: false,
                adaptiveHeight: true,
                prevArrow: $(this).find(".js-paging-prev"),
                nextArrow: $(this).find(".js-paging-next"),
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * locations
    // *
    // *
    function updateLocationsDotsScroll(slick, currentSlide, nextSlide) {
        if (!slick) return;

        // Ziel-Slide ermitteln (mit Fallback auf currentSlide für init/setPosition)
        const targetSlide = nextSlide !== undefined ? nextSlide : (slick.currentSlide || 0);
        const slidesToScroll = slick.options ? (slick.options.slidesToScroll || 1) : 1;
        const dotIndex = Math.floor(targetSlide / slidesToScroll);
        
        // Container spezifisch für Locations suchen
        const $dotsContainer = slick.$slider.closest('.js-locations').find('.js-paging-dots');
        const $dotsUl = $dotsContainer.find('.slick-dots');
        if (!$dotsUl.length) return;

        const $dots = $dotsUl.find('li');
        const totalDots = $dots.length;
        
        let maxVisibleDots = 10; 
        if (window.innerWidth < 400) {
            maxVisibleDots = 6;
        } else if (window.innerWidth < 500) {
            maxVisibleDots = 8;
        }

        if (totalDots <= maxVisibleDots) {
            $dotsUl.css('transform', 'translateX(0)');
            return;
        }

        let shiftIndex = dotIndex - Math.floor(maxVisibleDots / 2);
        if (shiftIndex < 0) shiftIndex = 0;
        if (shiftIndex > totalDots - maxVisibleDots) shiftIndex = totalDots - maxVisibleDots;

        const dotOuterWidth = $dots.first().outerWidth(true) || 26; 
        $dotsUl.css('transform', `translateX(-${shiftIndex * dotOuterWidth}px)`);
    }

    // ======================================================
    // LOCATIONS SLIDER INITIALISIERUNG
    // ======================================================
    var $locations = $(".js-locations");

    if ($locations.length) {
        $locations.each(function () {
            var $container = $(this);
            var $slider = $container.find(".js-locations-slider");
            var $pins = $container.find(".js-locations-pin");

            // WICHTIG: Die Events müssen VOR $slider.slick() definiert werden
            
            // 'setPosition' hinzugefügt, damit es auch beim Ändern der Fenstergröße funktioniert
            $slider.on('init setPosition', function (event, slick) {
                var i = slick.currentSlide || 0;
                $pins.removeClass("active");
                $pins.eq(i).addClass("active");
                
                // NEU: Scroll-Dots updaten
                updateLocationsDotsScroll(slick);
            });

            $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $pins.removeClass("active");
                $pins.eq(nextSlide).addClass("active");
                
                // NEU: Scroll-Dots updaten
                updateLocationsDotsScroll(slick, currentSlide, nextSlide);
            });

            $pins.each(function (index) {
                $(this).on("click", function () {
                    if (!$(this).hasClass("active")) {
                        $slider.slick("slickGoTo", index);
                    }
                });
            });

            $slider.slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 400,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                adaptiveHeight: true,
                prevArrow: $container.find(".js-paging-prev"),
                nextArrow: $container.find(".js-paging-next"),
                appendDots: $container.find(".js-paging-dots"),
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * boxImage
    // *
    // *
    var $boxImage = $(".js-boximage");

    if ($boxImage.length) {
        $boxImage.each(function () {
            var $currentContainer = $(this);
            var $slider = $currentContainer.find(".js-boximage-slider");
            
            // Wert aus data-autoplay auslesen (z.B. "3")
            var autoPlayData = $slider.data("autoplay");
            
            // Initialisiere Standardwerte
            var isAutoplay = false;
            var playSpeed = 2500; // Dein Standard-Fallback

            // Wenn der Wert existiert und eine Zahl ist
            if (autoPlayData && !isNaN(autoPlayData)) {
                isAutoplay = true;
                playSpeed = parseInt(autoPlayData) * 1000; // Umrechnung von Sekunden in ms
            }

            $slider.slick({
                fade: false,
                infinite: true,
                arrows: false,
                autoplay: isAutoplay, // Dynamischer Wert
                autoplaySpeed: playSpeed, // Dynamischer Wert
                speed: 800,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                adaptiveHeight: true,
                appendDots: $currentContainer.find(".js-paging-dots"),
            });
        });
    }




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this).find(".js-content-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-content-slider-dots"),
                prevArrow: $(this).find(".js-content-slider-prev"),
                nextArrow: $(this).find(".js-content-slider-next"),
            });

            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-content-slider-count").text(i);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * modal
    // *
    // *
// --- HILFSFUNKTIONEN ---

    // Generische Funktion zum Öffnen (funktioniert für Desktop UND Mobile Modals)
    function activateModal($modal) {
        if ($modal.length) {
            $modal.addClass('active');
            $modal.attr('tabindex', '0');
            $modal.attr('aria-hidden', 'false').focus();
            $('body').addClass('modal-open');
        }
    }

    // Generische Funktion zum Schließen
// Generische Funktion zum Schließen (KORRIGIERT/VERVOLLSTÄNDIGT)
    function deactivateModal($modal) {
        if ($modal && $modal.hasClass('active')) {
            $modal.removeClass('active');
            $modal.attr('aria-hidden', 'true');
            $modal.attr('tabindex', '-1'); // Hinzugefügt für A11y

            // Body-Scroll-Lock nur entfernen, wenn KEIN anderes Modal mehr offen ist
            if ($('.js-modal.active, .js-modalmobile.active').length === 0) {
                $('body').removeClass('modal-open');
            }
        }
    }

    // --- HAUPT-TRIGGER (Team-Liste) ---

    $('[data-modal-button]').on('click', function(e) {
        e.preventDefault();

        // Die ID des Ziels (z.B. "modal-1")
        const targetId = $(this).data('modal-button');
        
        // Prüfen, ob wir uns im Mobile/Tablet Modus befinden (< 800px)
        const isMobile = window.matchMedia('(max-width: 800px)').matches;

        if (isMobile) {
            // MOBILE LOGIK:
            // Wir bauen die ID um: aus "modal-1" wird "modalmobile-1"
            // Wir ersetzen "modal-" durch "modalmobile-"
            const mobileId = targetId.replace('modal-', 'modalmobile-');
            
            const $mobileModal = $('[data-modal="' + mobileId + '"]');
            
            // Falls ein passendes Mobile-Modal existiert, öffnen wir dieses
            if ($mobileModal.length) {
                activateModal($mobileModal);
            } else {
                // Fallback: Falls kein Mobile-Modal existiert, Desktop öffnen
                activateModal($('[data-modal="' + targetId + '"]'));
            }

        } else {
            // DESKTOP LOGIK (> 800px):
            // Direkt das große Modal öffnen
            activateModal($('[data-modal="' + targetId + '"]'));
        }
    });

    // --- BRIDGE: VOM MOBILE MODAL ZUM DESKTOP MODAL ---
    
    // Klick auf "Vita anzeigen" im Mobile Modal
    $('[data-modaldesktop-button]').on('click', function(e) {
        e.preventDefault();
        
        const desktopId = $(this).data('modaldesktop-button'); // z.B. "modal-1"
        
        // 1. Das aktuelle Mobile Modal schließen (das Elternelement)
        const $currentMobile = $(this).closest('.js-modalmobile');
        deactivateModal($currentMobile);

        // 2. Das Desktop Modal öffnen
        activateModal($('[data-modal="' + desktopId + '"]'));
    });


    // --- SCHLIESSEN-EVENT-LISTENER (Für Desktop UND Mobile) ---

    // Klick auf X-Button (konsolidiert für Desktop: .js-modal-close UND Mobile: .js-modalmobile-close)
    $('.js-modal-close, .js-modalmobile-close').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Stoppt die Bubbling (gut für Mobile-Logik)
        
        // 1. Fokus entfernen
        $(this).blur();
        document.activeElement.blur();
        
        // 2. Suche das nächste Elternelement, das entweder .js-modal oder .js-modalmobile ist
        // und rufe die zentrale Funktion auf.
        const $modalToClose = $(this).closest('.js-modal, .js-modalmobile');
        deactivateModal($modalToClose);
    });

    // 2. Schließen über Hintergrund-Klick (Desktop)
    $('.js-modal-content').on('click', function(e) {
        if (e.target === this) {
            deactivateModal($(this).closest('.js-modal'));
        }
    });

    // 3. Schließen über Hintergrund-Klick (Mobile)
    // Hier nutzen wir .js-modalmobile-content analog zu Desktop
    $('.js-modalmobile-content').on('click', function(e) {
        if (e.target === this) {
            deactivateModal($(this).closest('.js-modalmobile'));
        }
    });

    // 4. ESC Taste
    $(document).on('keydown', function(e) {
        if (e.keyCode === 27) {
            // Schließe alle aktiven Modals
            deactivateModal($('.js-modal.active, .js-modalmobile.active'));
        }
    });
    
    // Initialisierung A11y
    $('.js-modal, .js-modalmobile').attr('aria-hidden', 'true').attr('tabindex', '-1');



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * video
    // *
    // *
    // Klick NUR auf den Play-Button
    $(".video__icon,.boxImage__videoIcon").on("click", function () {
        const wrapper = $(this).closest(".js-video-wrapper");
        const video = wrapper.find(".js-video")[0];
        
        video.play();
    });

    // 2. Sobald das Video läuft (egal ob per Klick oder Tastatur)
    $(".js-video").on("play", function() {
        const video = this;
        const wrapper = $(video).closest(".js-video-wrapper");
        
        // Overlay ausblenden
        wrapper.addClass("active");
        
        // Alle anderen Videos auf der Seite stoppen
        $(".js-video").each(function() {
            if (this !== video) {
                this.pause();
            }
        });
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * form
    // *
    // *
    var $fileBtn     = $('.js-file-btn');
    var $fileInput   = $('.js-file-input');
    var $fileDisplay = $('.js-file-display');
    var $selects     = $('.js-select');

    // 1. Logik für den Custom File Upload
    $fileBtn.on('click', function() {
        $fileInput.trigger('click');
    });

    $fileInput.on('change', function() {
        var files = $(this)[0].files;

        if (files.length > 1) {
            $fileDisplay.text(files.length + ' Dateien ausgewählt');
        } else if (files.length === 1) {
            $fileDisplay.text(files[0].name);
        } else {
            $fileDisplay.text('Keine Datei gewählt');
        }
    });

    // 2. Select Styling Korrektur
    $selects.on('change', function() {
        $(this).css('color', '#2B2F34');
    });


     // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * jobs logik
    // *
    // *
    var $positionSelect = $('#position');
    var $locationSelect = $('#location');
    var $locationOptions = $locationSelect.find('option:not(:first)'); // Den "Bitte auswählen" Platzhalter ignorieren

    function filterLocations() {
        var $selectedPosition = $positionSelect.find('option:selected');
        // .attr() ist hier sicherer als .data(), falls MODX leere Werte rendert
        var allowedLocationsStr = $selectedPosition.attr('data-locations'); 

        // Wenn keine Position gewählt ist ODER die Position keine Standorte hinterlegt hat
        if (!allowedLocationsStr) {
            $locationSelect.prop('disabled', true); // Haupt-Select sperren
            $locationOptions.prop('disabled', true).hide(); // Optionen verstecken
            $locationSelect.val(''); // Wert zurücksetzen
            return;
        }

        // Wenn eine gültige Position gewählt wurde, Haupt-Select entsperren
        $locationSelect.prop('disabled', false); 

        // String in Array umwandeln
        var allowedLocations = String(allowedLocationsStr).split(',').map(function(item) {
            return item.trim();
        });

        // Jeden Standort prüfen
        $locationOptions.each(function() {
            var $opt = $(this);
            var optId = $opt.attr('data-id'); 

            if ($.inArray(optId, allowedLocations) !== -1) {
                $opt.prop('disabled', false).show();
            } else {
                $opt.prop('disabled', true).hide();
            }
        });

        // Sicherheits-Check für FormIt-Reloads
        var $currentSelectedLoc = $locationSelect.find('option:selected');
        var currentLocId = $currentSelectedLoc.attr('data-id');
        
        if (currentLocId && $.inArray(currentLocId, allowedLocations) === -1) {
            $locationSelect.val('');
        }
    }

    // Beim Dropdown-Wechsel ausführen
    $positionSelect.on('change', filterLocations);

    // Initial beim Seitenaufruf IMMER ausführen
    // Die Funktion kümmert sich selbst darum, ob das Select gesperrt werden muss oder nicht
    filterLocations();

});








// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
        $(".buttonAside").addClass("hide");
    } else {
        $(".js-header").removeClass("sticky");
        $(".buttonAside").removeClass("hide");
    }

    var isBottom = $(window).scrollTop() + $(window).height() >= $(document).height() - 20;
    
    $('#dmrWrapper').toggleClass('slideUp', isBottom);
});




// ======================================================
// 1. RATINGS – SLICK
// ======================================================

function getRatingsOptions($container) {
    return {
        infinite: true,
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        appendDots: $container.find(".js-paging-dots"),
        prevArrow: $container.find(".js-paging-prev"),
        nextArrow: $container.find(".js-paging-next"),
        responsive: [
            { breakpoint: 1400, settings: { slidesToShow: 2} },
            { breakpoint: 1200, settings: { slidesToShow: 1} }
        ]
    };
}

function updateDotsScroll(slick, currentSlide, nextSlide) {
    const targetSlide = nextSlide !== undefined ? nextSlide : 0;
    const dotIndex = Math.floor(targetSlide / slick.options.slidesToScroll);
    
    const $dotsContainer = slick.$slider.closest('.js-ratings').find('.js-paging-dots');
    const $dotsUl = $dotsContainer.find('.slick-dots');
    const $dots = $dotsUl.find('li');
    
    const totalDots = $dots.length;
    let maxVisibleDots = 10; 
    if (window.innerWidth < 400) {
        maxVisibleDots = 6;
    } else if (window.innerWidth < 500) {
        maxVisibleDots = 8;
    }

    if (totalDots <= maxVisibleDots) {
        $dotsUl.css('transform', 'translateX(0)');
        return;
    }

    let shiftIndex = dotIndex - Math.floor(maxVisibleDots / 2);
    if (shiftIndex < 0) shiftIndex = 0;
    if (shiftIndex > totalDots - maxVisibleDots) shiftIndex = totalDots - maxVisibleDots;

    const dotOuterWidth = $dots.first().outerWidth(true); // Liest Breite + Margin aus
    $dotsUl.css('transform', `translateX(-${shiftIndex * dotOuterWidth}px)`);
}

function applyRatingsFilterLogic(filterGroup, filterValue, $selectedOption) {
    const $ratings = $selectedOption.closest(".js-ratings");
    const $slider = $ratings.find(".js-ratings-slider");
    const $original = $slider.data("originalSlides");

    if (!$original) return;

    if ($slider.hasClass("slick-initialized")) {
        try { $slider.slick("unslick"); } catch (e) {}
    }

    $slider.empty();

    if (filterValue === "all") {
        $original.clone().appendTo($slider);
    } else {
        const $matched = $original.filter(function () {
            return $(this).data("filter") === filterValue;
        });

        $matched.length
            ? $matched.clone().appendTo($slider)
            : $slider.append('<div class="rating rating--empty">Keine Bewertungen gefunden.</div>');
    }

    $slider.slick(getRatingsOptions($ratings));
}


// ======================================================
// 2. TEAM – MIXITUP (KOMPLETT GEKAPSELT)
// ======================================================

function updateTeamResetButton($team) {
    const state = $team.data("filterState");
    const active = Object.values(state).some(v => v !== "all");
    $team.find(".js-filter-reset").toggleClass("active", active);
}

function applyTeamFilterLogic(filterGroup, filterValue, $selectedOption) {
    const $wrapper = $selectedOption.closest(".js-filter-wrapper");
    const $team = $wrapper.data("team");

    if (!$team || !$team.length) return;

    const mixer = $team.data("mixer");
    const state = $team.data("filterState");

    state[filterGroup] = filterValue;

    const selector = Object.values(state)
        .filter(v => v !== "all")
        .join("");

    mixer.filter(selector || "all");
    updateTeamResetButton($team);
}


// ======================================================
// 3. GENERISCHE FILTER-DROPDOWN-UI
// ======================================================

function initializeFilterDropdown($wrapper, onApplyFilter) {
    const $button = $wrapper.find(".js-filter-dropdown-button");
    const $dropdown = $wrapper.find(".js-filter-dropdown");
    const $options = $dropdown.find("[role='option']");
    const $label = $wrapper.find(".js-filter-active");

    function close() {
        $wrapper.removeClass("open");
        $button.attr("aria-expanded", "false");
        $dropdown.slideUp(150);
    }

    function open() {
        $wrapper.addClass("open");
        $button.attr("aria-expanded", "true");
        $dropdown.slideDown(150);
        
        // Fokus direkt setzen, damit der Nutzer sofort mit Tab weiter navigieren kann
        const $active = $options.filter(".active");
        if ($active.length) {
            $active.focus();
        } else {
            $options.first().focus();
        }
    }

    function select($opt) {
        $label.text($opt.data("text"));
        $options.attr({ "aria-selected": "false", tabindex: "-1" }).removeClass("active");
        $opt.attr({ "aria-selected": "true", tabindex: "0" }).addClass("active");
        
        close();
        
        // Fokus zurück auf den Button, damit der Nutzer auf der Seite nicht "verloren" geht
        $button.focus(); 

        onApplyFilter(
            $wrapper.data("filter-group"),
            $opt.data("filter"),
            $opt
        );
    }

    $button.on("click", () => $wrapper.hasClass("open") ? close() : open());
    $options.on("click", function () { select($(this)); });

    $dropdown.on("keydown", "[role='option']", function (e) {
        const i = $options.index(this);

        if (e.key === "Tab") {
            if (e.shiftKey) {
                // Shift + Tab (rückwärts)
                if (i > 0) {
                    e.preventDefault(); // Standard-Tab blockieren, intern weitergehen
                    $options.eq(i - 1).focus();
                } else {
                    // Oben angekommen: Standardverhalten (raus-tabben nach oben) zulassen & Dropdown schließen
                    close();
                }
            } else {
                // Nur Tab (vorwärts)
                if (i < $options.length - 1) {
                    e.preventDefault(); // Standard-Tab blockieren, intern weitergehen
                    $options.eq(i + 1).focus();
                } else {
                    // Unten angekommen: Standardverhalten (raus-tabben nach unten) zulassen & Dropdown schließen
                    close();
                }
            }
        }

        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault(); // Verhindert z.B. unerwünschtes Scrollen bei Leertaste
            select($(this));
        }

        if (e.key === "Escape") {
            e.preventDefault();
            close();
            $button.focus();
        }
    });

    $(document).on("click", e => {
        if ($wrapper.hasClass("open") && !$wrapper.is(e.target) && !$wrapper.has(e.target).length) {
            close();
        }
    });
}


// ======================================================
// 4. INITIALISIERUNG
// ======================================================

$(document).ready(function () {

    // ---------- TEAM ----------
    $(".js-team").each(function () {
        const $team = $(this);
        const list = $team.find(".js-team-item-list").get(0);
        if (!list) return;

        const mixer = mixitup(list, {
            selectors: { target: ".js-filter-item" },
            animation: { duration: 300 },
            controls: {
                scope: 'local' // 🔑 Sorgt dafür, dass der Mixer nur auf Filter im eigenen Container reagiert
            }
        });

        const filterState = {};
        $team.data({ mixer, filterState });

        // Filter initialisieren + explizit binden
        $team.find(".js-filter-wrapper").each(function () {
            const $wrapper = $(this);
            const group = $wrapper.data("filter-group");
            if (group) filterState[group] = "all";

            // 🔑 entscheidend
            $wrapper.data("team", $team);

            initializeFilterDropdown($wrapper, applyTeamFilterLogic);
        });

        // Reset
        $team.find(".js-filter-reset").on("click", function (e) {
            e.preventDefault();

            Object.keys(filterState).forEach(k => filterState[k] = "all");
            mixer.filter("all");

            $team.find(".js-filter-wrapper").each(function () {
                const $w = $(this);
                const $all = $w.find("[data-filter='all']");
                $w.find(".js-filter-active").text($all.data("text"));
                $w.find("[role='option']")
                    .attr({ "aria-selected": "false", tabindex: "-1" })
                    .removeClass("active");
                $all.attr({ "aria-selected": "true", tabindex: "0" }).addClass("active");
            });

            updateTeamResetButton($team);
        });

        updateTeamResetButton($team);
    });


    // ---------- RATINGS ----------
    $(".js-ratings").each(function () {
        const $ratings = $(this);
        const $slider = $ratings.find(".js-ratings-slider");

        // HIER DIE NEUEN EVENTS HINZUFÜGEN (Wichtig: vor $slider.slick(...))
        $slider.on('init', function(event, slick) {
            updateDotsScroll(slick, 0, 0);
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            updateDotsScroll(slick, currentSlide, nextSlide);
        });
        // ENDE NEUE EVENTS

        $slider.data("originalSlides", $slider.children().clone());
        $slider.slick(getRatingsOptions($ratings));

        $ratings.find(".js-filter-wrapper").each(function () {
            initializeFilterDropdown($(this), applyRatingsFilterLogic);
        });
    });

});


